import EditPrivateRoomSidePane from "./EditPrivateRoomSidePane";
export default EditPrivateRoomSidePane;
